import {
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Select,
} from "@chakra-ui/react";
import { KYDTicketType } from "@common/interfaces/KYDTicket";
import { MdCancel } from "react-icons/md";
import {
  useClearRefinements,
  useInstantSearch,
  useMenu,
  useSearchBox,
} from "react-instantsearch";

const AttendeesFilter = ({
  ticketTypes = [],
}: {
  ticketTypes?: KYDTicketType[];
}) => {
  const { status } = useInstantSearch();
  const { refine, query } = useSearchBox();

  const { refine: clearRefinements } = useClearRefinements({
    includedAttributes: ["ticket_type_ids"],
  });
  const { refine: refineParameters } = useMenu({
    attribute: "ticket_type_ids",
  });

  return (
    <HStack justify={"space-between"} w="full">
      <InputGroup>
        <Input
          placeholder="Search for attendees..."
          value={query}
          onChange={(e) => refine(e.target.value)}
        />

        <InputRightElement>
          <IconButton
            isLoading={status === "loading"}
            isDisabled={query === ""}
            disabled={query === ""}
            variant={"ghost"}
            background="transparent"
            aria-label="Cancel"
            icon={<MdCancel />}
            onClick={() => refine("")}
          />
        </InputRightElement>
      </InputGroup>
      <Select
        maxW={"200px"}
        defaultValue={""}
        onChange={(e) => {
          if (!e.target.value) {
            clearRefinements();
            return;
          }

          refineParameters(e.target.value);
        }}
      >
        <option value="">All ticket types</option>
        {ticketTypes.map((tt) => (
          <option value={tt.id}>{tt.name || "System ticket type"}</option>
        ))}
      </Select>
    </HStack>
  );
};

export default AttendeesFilter;
